import styled from 'styled-components';

import S from '../variables';

export const StyledRadioButton = styled.div`
  width: 38px;
  height: 38px;
  background: ${S.defaultPrimaryButton};
  border-radius: 5px;
  color: ${S.mainGreyText};
  font-size: 12px;
  font-weight: 400;
  line-height: 38px;
  text-align: center;
  cursor: pointer;
  &:not(:last-child) {
    margin-right: 8px;
  }
  &.selected {
    background: ${S.accentGold};
    color: #fff;
  }
  &[disabled] {
    background: white;
    color: ${S.mainGreyText};
    cursor: not-allowed;
    border: 1px solid ${S.disabledBorder};
  }
  @media screen and (min-width: ${S.tablet}) {
    width: 45px;
    height: 45px;
    line-height: 45px;
  }
`;

export const StyledRadio = styled.div`
  height: 38px;
  display: flex;
  justify-content: flex-start;
  @media screen and (min-width: ${S.tablet}) {
    height: 45px;
  }
`;

export const StyledRoundRadio = styled.ul`
  min-height: 20px;
  width: ${props => props.wd || '100%'};
  display: flex;
  flex-wrap: wrap;
`;

export const StyledRoundRadioButtonWrapper = styled.li`
  display: flex;
  width: calc((100% - 72px) / 2);
  &:not(:last-child) {
    margin-right: 36px;
  }
  & > .circle {
    margin-right: 8px;
  }
  & > .text {
    font-weight: 400;
    &.small {
      font-size: 12px;
    }
  }
`;

export const StyledRoundRadioButton = styled.div`
  flex-shrink: 0;
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: ${props => (props.square ? '2px' : '50%')};
  background: #fff;
  border: 1px solid ${S.mainBlackText};
  margin-bottom: 10px;
  cursor: pointer;
  &:after {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: scale(0);
    transition: transform ${S.trOverflowFast};
  }
  &.selected:after {
    background: ${S.accentGold};
    transform: scale(1);
  }
`;
